import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.main/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageMainComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();

        if (!this.service.auth.session || !this.service.auth.session.id) {
            this.service.href('/login');
            return;
        }

        const res = await wiz.call("redirect_check");
        if (res.code === 200 && res.data) {
            this.service.href(res.data);
        } else {
            this.service.href('/center/research');
        }
    }
}

export default PageMainComponent;